import { jsPDF } from "jspdf";

export const generateCertificatePDF = async (userName: string, eventName: string = "Evento Internacional GIEPEI", modality: string = "Presencial") => {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4"
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // Cargar la imagen base del certificado como fondo de página completa
  const imgUrl = "/modelo-certificado.png";
  doc.addImage(imgUrl, "PNG", 0, 0, pageWidth, pageHeight);

  // Área de texto en la imagen: X 1300-3400px, Y 500-1800px (a 300 DPI)
  // Con márgenes internos de ~50px cada lado → área efectiva: X 1400-3300px, Y 600-1700px
  // En mm (300 DPI = 25.4mm/300px ≈ 0.0847mm/px):
  const marginX = 1400 * 0.0847;  // ~119mm desde izquierda
  const marginY = 600 * 0.0847;   // ~51mm desde arriba
  const textWidth = (3300 - 1400) * 0.0847;  // ~161mm ancho útil
  const textHeight = (1700 - 600) * 0.0847;  // ~93mm alto útil
  const centerX = marginX + textWidth / 2;   // ~199mm centro horizontal
  let currentY = marginY + 10;               // ~61mm inicio vertical (margen superior)

  doc.setTextColor(51, 51, 51);
  doc.setFont("times", "normal");

  // "A Comissão de Organização GIEPEI certifica que"
  doc.setFontSize(20);
  doc.text("A Comissão de Organização GIEPEI certifica que", centerX, currentY, { align: "center", maxWidth: textWidth });
  currentY += 24; // margen vertical equilibrado

  // Nombre del participante
  doc.setFont("times", "bold");
  doc.setFontSize(34);
  doc.text(userName.toUpperCase(), centerX, currentY, { align: "center", maxWidth: textWidth });
  currentY += 24; // margen vertical equilibrado (igual que arriba)

  // Cuerpo del certificado
  doc.setFont("times", "normal");
  doc.setFontSize(16);
  const bodyText = `Participou do 1.º Seminário do Grupo Internacional de Estudo e Pesquisa em Educação de Infâncias (GIEPEI) na modalidade Presencial, nos dias 13, 14 e 15 de Julho do ano 2026.`;
  const splitBody = doc.splitTextToSize(bodyText, textWidth);
  doc.text(splitBody, centerX, currentY, { align: "center" });
  currentY += splitBody.length * 7 + 8; // margen vertical reducido antes de firmas

  // Espacio para firmas (2 firmas: Brasil y Luanda)
  const signatureY = currentY;
  const signatureGap = 90; // espacio horizontal entre firmas
  const leftSigX = centerX - signatureGap / 2;
  const rightSigX = centerX + signatureGap / 2;

  // Firma 1 (Brasil)
  doc.setFontSize(12);
  doc.setFont("times", "normal");
  doc.text("________________________", leftSigX, signatureY, { align: "center" });
  doc.text("Prof. Doutor Alberto Nguluve", leftSigX, signatureY + 10, { align: "center" });
  doc.text("Coordenador do GIEPEI - ANGOLA", leftSigX, signatureY + 18, { align: "center" });

  // Firma 2 (Luanda)
  doc.text("________________________", rightSigX, signatureY, { align: "center" });
  doc.text("Profª Claudia Oliveira Fernandes", rightSigX, signatureY + 10, { align: "center" });
  doc.text("Coordenadora do GIEPEI - BRASIL", rightSigX, signatureY + 18, { align: "center" });

  doc.save(`Certificado_GIEPEI_${userName.replace(/\s+/g, '_')}.pdf`);
};
